import { render } from "./CreateAnnouncement.vue?vue&type=template&id=2ca93497"
import script from "./CreateAnnouncement.vue?vue&type=script&lang=js"
export * from "./CreateAnnouncement.vue?vue&type=script&lang=js"
script.render = render

export default script